import en from './strings.en';

const ru = {
    company: 'Фирма',
    trucksCount: 'Всего размещалось машин',
    trucksCountTooltip: 'Сколько всего машин перевозчик выставлял по\u00A0указанному направлению. Чем\u00A0больше значение, тем\u00A0вероятнее, что\u00A0участника заинтересует ваш\u00A0груз.',
    searchCount: 'Всего искали грузов',
    searchCountTooltip: 'Сколько раз\u00A0перевозчик искал грузы по\u00A0указанному направлению. Чем\u00A0больше значение, тем\u00A0вероятнее, что\u00A0участника заинтересует ваш\u00A0груз.',
    actualTrucks: 'Машины, готовые к загрузке',
    actualTrucksTooltip: 'Сколько машин прямо сейчас готовы к\u00A0загрузке по\u00A0указанному направлению.',
    canSelectAndInvite: 'Теперь можно выбрать всех перевозчиков и\u00A0пригласить их на свою площадку или добавить в список'
};

export default { ru, en: { ...ru, ...en} };
